mutation DripSequenceActivate($input: DripSequenceActivateInput!) {
    dripSequenceActivate(input: $input) {
        dripSequence {
            id
        }
    }
}
